import { httpClient } from "@/lib/http-client/http-client";
import { API_ROUTES } from "@/shared/constants/api.routes";
import { ICountryResponse, IJobResponse } from "../interface/responses/IConstants";
import { ISectorResponse } from "../interface/responses/IConstants";
import { ILanguageResponse } from "../interface/responses/IConstants";
  
class ConstantsService {
  constructor() {}

  public async getCountries() {
    const response = await httpClient.get<ICountryResponse[]>(API_ROUTES.Constants.countries);
    return response;
  }

  public async getJobs() {
    const response = await httpClient.get<IJobResponse[]>(API_ROUTES.Constants.jobs);
    return response;
  }

    public async getSectors() {
    const response = await httpClient.get<ISectorResponse[]>(API_ROUTES.Constants.sectors);
    return response;
  }

  public async getLanguages() {
    const response = await httpClient.get<ILanguageResponse[]>(API_ROUTES.Constants.languages);
    return response;
  }
  }

export default new ConstantsService();